import service from "../services/settings.service";
import { applyThemeColors } from "../utils/themeColors";

export const settings = {
    namespaced: true,
    state: {
        data: null,
    },
    getters: {
        serviceOrdersEnabled(state) {
            if (state.data?.service_orders_enabled === undefined || state.data?.service_orders_enabled === null) {
                return true;
            }
            return Boolean(state.data.service_orders_enabled);
        },
        employeeCommissionPercent(state) {
            const value = parseFloat(state.data?.employee_commission_percent);
            if (!Number.isFinite(value)) {
                return 70;
            }
            return Math.max(0, Math.min(100, value));
        },
        employeeCommissionRate(state, getters) {
            return getters.employeeCommissionPercent / 100;
        },
    },
    actions: {
        async get({ commit, state }, data) {
            if (state.data && !data?.force) {
                return { data: state.data };
            }
            try {
                const response = await service.get(data);
                if (response?.data) {
                    commit('SET_DATA', response.data);
                }
                return response;
            } catch (error) {
                console.error("Error fetching get data:", error);
                throw error.response;
            }
        },
        async save({ commit }, data) {
            try {
                const response = await service.updateData(data);
                if (response?.data) {
                    commit('SET_DATA', response.data);
                }
                return response;
            } catch (error) {
                console.error("Error fetching get data:", error);
                throw error.response;
            }
        },
    },
    mutations: {
        SET_DATA(state, data) {
            state.data = data;
            applyThemeColors(data);
        },
    },
};
